import Highcharts from "highcharts";

import { AdditionalWidgetData } from "@/types/additional-widget-data";
import { HighCharts } from "@/features/shared/components";
import { COLORS } from "@/features/shared/constants";
import { convertSeriesDataToHighchartsSeries } from "@/features/shared/widgets";
import { Serie } from "@/types/serie";
import useRefetchWidget from "@/features/shared/widgets/hooks/useRefetchWidget";

type Props = {
  id: string;
  data: AdditionalWidgetData;
};

const X_AXIS_TICK_INTERVAL = 6 * 3600 * 1000;
const X_AXIS_MINOR_TICK_INTERVAL = 3 * 3600 * 1000;

const generateSeries = (series: Serie[]) => {
  return series.map((serie) => {
    const transformedData = convertSeriesDataToHighchartsSeries(serie);
    const lineData = transformedData.map(([date, value]) => {
      return [date.getTime(), value];
    });

    return {
      data: lineData,
      marker: {
        enabled: false,
      },
      name: serie.translatedName || serie.name,
    } as Highcharts.SeriesOptionsType;
  });
};

const Probabilities = ({ id, data }: Props) => {
  useRefetchWidget(id);

  const series = data.data;

  const config: Highcharts.Options = {
    colors: Object.values(COLORS.default)
      .reverse()
      .concat(Object.values(COLORS.max).reverse()),

    title: undefined,
    xAxis: {
      type: "datetime",
      tickInterval: X_AXIS_TICK_INTERVAL,
      minorTickInterval: X_AXIS_MINOR_TICK_INTERVAL,
    },
    yAxis: {
      min: 0,
      max: 100,
      stackLabels: {
        enabled: true,
      },
    },
    chart: {
      type: "column",
    },
    plotOptions: {
      column: {
        grouping: false,
        animation: false,
      },
    },
    tooltip: {
      valueSuffix: "%",
      shared: true,
    },
    series: generateSeries(series),
  };

  return <HighCharts options={config} />;
};

export default Probabilities;
